import React, { useRef, useEffect, useState } from "react";
import { FilterItem } from "../../types/types";

interface FilterGroupProps {
    name: string;
    title: string;
    filters: FilterItem[];
    onToggleFilter: (groupName: string, filterName: string) => void;
}

const FilterGroup: React.FC<FilterGroupProps> = ({ name, title, filters, onToggleFilter }) => {
    const containerRef = useRef<HTMLUListElement | null>(null);
    const pillRef = useRef<HTMLLIElement | null>(null);
    const [containerHeight, setContainerHeight] = useState(0);
    const [pillHeight, setPillHeight] = useState(0);
    const [expanded, setExpanded] = useState(false);
    const [showToggle, setShowToggle] = useState(false);

    useEffect(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (containerRef.current) setContainerHeight(containerRef.current.offsetHeight);
            if (pillRef.current) setPillHeight(pillRef.current.offsetHeight);
        });

        if (containerRef.current) resizeObserver.observe(containerRef.current);
        if (pillRef.current) resizeObserver.observe(pillRef.current);

        return () => resizeObserver.disconnect();
    }, [filters]);

    useEffect(() => {
        if (pillHeight && containerHeight) {
            const maxAllowed = pillHeight;
            setShowToggle(containerHeight > maxAllowed);
        }
    }, [pillHeight, containerHeight]);

    const maxHeight = expanded ? containerHeight : pillHeight;

    return (
        <div>
            <h3 className="recipe-filter__type-title">{title}</h3>
            <div className="recipe-filter__group" style={{ maxHeight }}>
                <ul ref={containerRef} className="recipe-filter__items">
                    {filters.map((filter, index) => (
                        <li
                            key={index}
                            ref={index === 0 ? pillRef : null}
                        >
                            <button
                                className={`recipe-filter__item ${filter.selected ? "recipe-filter__item--active" : ""}`}
                                onClick={() => onToggleFilter(name, filter.name)}
                                disabled={filter.disabled}
                            >
                                {filter.title}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            {showToggle && (
                <button
                    className={`recipe-filter__toggle ${expanded ? "recipe-filter__toggle-expanded" : ""}`}
                    onClick={() => setExpanded((prev) => !prev)}
                >
                    {expanded ? "Visa färre" : "Visa fler"}
                </button>
            )}
        </div>
    );
};

export default FilterGroup;
